<template>
<modal name="my-second-modal">
  <div class="pop-up-add-image"  >
    <div class="upload-area-wrapper">
        <img :src="url" alt="" />
    </div>
    <div class="upload__btns">
      <button class="btn-accent btn-block mr-3" @click="hide">Huỷ</button>
    </div>
  </div>
</modal>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
Vue.use(VModal)

export default {
  name: "PopUpAddImage",

  props: {
    uploadToSpace: {
      type: String,
      required: false,
      default: "imurl"
    }
  },
  props: {
    url: {
      type: String
    }
  },
  methods: {
    show () {
        this.$modal.show('my-second-modal');
    },
    hide () {
        this.$modal.hide('my-second-modal');
    },
  }
}
</script>

<style lang="scss" scoped>
.mr-3{
  margin-right: 16px !important;
}
.btn-accent{
  background: #ff8200;
  border: 0;
  border-radius: 2px;
  height: 48px;
  margin: 0 auto;
  color: #fff;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  &.disabled{
    background: rgba(0,0,0,.12);
    color: #000;
  }
}

.btn-block{
  width: 100%;
}
.upload__btns{
  display: flex;
}

.pop-up-add-image{
  padding: 25px 15px;
  width: 100%;
  text-align: center;
  background: #fff;
  
}
.upload-area-wrapper {
  height: 380px;
  padding: 0 16px;
  border-radius: 12px;
  margin: 50px 0;
  
    img{
      width: auto;
      max-height: 400px;
    }

}

@media screen and (max-width: 500px) {
  
  .pop-up-add-image{

    height: 100vh;
  }
}

@media screen and (max-height: 812px) and ( max-width: 500px) {
  
  .pop-up-add-image{
    height: 120vh;
  }
}

</style>>
